import { ButtonBase } from '@mui/material';
import { cssWhen } from '../../utils/themeUtils';
import classes from './TradeTypeSwitch.module.scss';

export interface TradeTypeSwitchProps<T> {
  className?: string;
  selectedValue: T;
  left: {
    name: string;
    value: T;
  };
  right: {
    name: string;
    value: T;
  };
  onChange: (value: T) => void;
  disabled?: boolean;
  readOnly?: boolean;
}

export function TradeTypeSwitch<T>({
  className,
  selectedValue,
  left,
  right,
  onChange,
  disabled,
  readOnly,
}: TradeTypeSwitchProps<T>) {
  if (selectedValue !== left.value && selectedValue !== right.value) {
    throw new Error(
      `NbTextSwitch: selectedValue must be "${left.value}" or "${right.value}", but got "${selectedValue}"`,
    );
  }

  return (
    <div
      className={cssWhen(
        classes.textSwitch,
        [className, className!],
        [selectedValue === left.value, classes.textSwitchIsLeftActive],
        [selectedValue !== left.value, classes.textSwitchIsRightActive],
        [disabled, classes.textSwitchIsDisabled],
      )}
    >
      <ButtonBase
        onClick={() => {
          if (readOnly) {
            return;
          }
          onChange(left.value);
        }}
        data-testid="order-trade-type-sell-button"
        disabled={disabled}
        disableRipple
      >
        <div
          className={`${classes.Text} ${classes.TextIsLeft} ${selectedValue === left.value && classes.TextIsActive}`}
        >
          {left.name}
        </div>
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          if (readOnly) {
            return;
          }
          onChange(right.value);
        }}
        data-testid="order-trade-type-buy-button"
        disableRipple
        disabled={disabled}
      >
        <div
          className={`${classes.Text} ${classes.TextIsRight} ${selectedValue === right.value && classes.TextIsActive}`}
        >
          {right.name}
        </div>
      </ButtonBase>
    </div>
  );
}
